import { useEntityPageCoverImageQuery } from './CoverImageQuery.gql-types';
import { NORMAL_DIMENSIONS } from './constants';

const useCoverMedia = (pageSlug: string) =>
  useEntityPageCoverImageQuery({
    variables: { id: pageSlug, dimensions: NORMAL_DIMENSIONS },
    errorPolicy: 'all',
  });

export default useCoverMedia;
